import { TableRow, TableCell } from "@/components/ui/table";
import { Table, flexRender } from "@tanstack/react-table";
import { memberColumns } from "./MemberColumns";
import { MemberTable } from "./types";

type Props<TData> = {
  table: Table<TData>;
  rowClickAction?: () => void;
  isFiltered: boolean;
};

export const MembersTableContent = <TData extends MemberTable>({
  table,
  rowClickAction,
  isFiltered
}: Props<TData>) => {
  return table.getRowModel().rows.length ? (
    table.getRowModel().rows.map((row) => {
      return (
        <TableRow
          onClick={rowClickAction}
          className="h-16"
          key={row.id}
          data-state={row.getIsSelected() && "selected"}
        >
          {row.getVisibleCells().map((cell) => (
            <TableCell className="first:w-16" key={cell.id}>
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </TableCell>
          ))}
        </TableRow>
      );
    })
  ) : (
    <TableRow>
      <TableCell colSpan={memberColumns.length} className="h-16 text-center">
        {isFiltered
          ? "No members were found"
          : "Your organization has no members."}
      </TableCell>
    </TableRow>
  );
};
